import React, { useState } from 'react';
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonSearchbar, IonGrid, IonRow, IonCol, IonButton } from '@ionic/react';
import { getArasaacImages, searchUnsplashImages } from '../foo';
import { _dict } from '../constants';


interface ModalProps {
  isOpen: boolean;
  lang: string;
  onDidDismiss: (selectedImage: string | null) => void;
  where: string;
}

const SearchModal: React.FC<ModalProps> = ({ isOpen, lang, onDidDismiss, where }) => {
  const [searchText, setSearchText] = useState('');
  const [images, setImages] = useState<(string | null)[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e: CustomEvent) => {
    setLoading(true);
    setSearchText(e.detail.value);
    let results: any = [];
    if(where === "arasaac"){
        results = await getArasaacImages(lang, e.detail.value, 10);
    }else if(where === "unsplash"){
        results = await searchUnsplashImages(lang, e.detail.value, 10);
    }

    setImages(results || []);
    setLoading(false);
  };

  const handleSelectImage = (image: string | null) => {
    if (selectedImage === image) {
      setSelectedImage(null);
    } else {
      setSelectedImage(image);
    }
  };

  const handleConfirm = () => {
    onDidDismiss(selectedImage);
  };

  return (

    <IonModal isOpen={isOpen} onDidDismiss={() => onDidDismiss(null)}
    
    >
      

      <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
          <IonButton onClick={() => onDidDismiss(null)} color="danger" size="large">
            {_dict.dismiss[lang]}
          </IonButton>
          {selectedImage && (
  
          <IonButton onClick={handleConfirm} size="large" color="success">
            {_dict.confirm[lang]}
          </IonButton>
        )}
        </div>

      <IonContent >
        
        
        <IonSearchbar value={searchText} onIonChange={handleSearch} placeholder={_dict.searchImages[lang]}/>
        
        {loading ? <div style={{textAlign:"center"}}>{_dict.loading[lang]}</div> :
        images.length === 0 ? <div style={{textAlign:"center"}}>{_dict.noResult[lang]}</div> :
        <IonGrid>
          <IonRow>
            {images.map((image, index) => (
              <IonCol size="3" key={index}>
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                  <img
                    src={image || ''}
                    alt=""
                    style={{
                      width: '100%',
                      cursor: 'pointer',
                      border: selectedImage === image ? '3px solid green' : '',
                    }}
                    onClick={() => handleSelectImage(image)}
                  />
                </div>
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>}
        
      </IonContent>
    </IonModal>
  );
  
};

export default SearchModal;
